import log from 'salvo-lite/log'
// import axios from 'axios'
import jQuery from 'jquery'

class Account {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem

        log.debug(this._name, 'Constructed', this)
    }

    onInit () {
        jQuery('#CustomerEmail').change(function () {
            var email = jQuery(this).val()
            // var ajaxURL = `/admin/customers/search.json?query=email:${email}&fields=id,email`
            // var ajaxURL = `/admin/customers/search.json?query=email:${email};fields=email,id`
            // var ajaxURL = `/admin/api/2020-04/customers/search.json?query=email:${email}`
            console.log('email1 = ', email)

            // return axios.get(ajaxURL).then((response) => {
            //     console.log('response = ', response)
            // }).catch((error) => {
            //     console.log('email2 = ', email)
            //     console.log(error)
            // })
        })
    }
}

export default Account



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Account.js